import React from 'react';
import { StanInput } from '../../StanInput/StanInput';
import { StanDropdownInputProps } from '../../types';
import IconChevronDown from '@/assets/icons/ic-chevron-down.svg';
import { useDropdown } from '../DropdownProvider';
import { cn } from '@/lib';
import styles from '@/components/core-components/StanInput/StanInput.module.css';

export const StanDropdownInput: React.FC<StanDropdownInputProps> = ({
    id,
    name,
    label,
    placeholder = 'Select an option',
    value = '',
    required = false,
    disabled = false,
    className = '',
    error = false,
    hintText,
    startIcon,
}) => {
    const { isOpen } = useDropdown();
    return (
        <StanInput
            id={id}
            name={name}
            innerLabel={label}
            placeholder={placeholder}
            value={value}
            onChange={() => {}}
            required={required}
            disabled={disabled}
            readOnly
            className={cn(className, disabled ? 'cursor-not-allowed' : 'cursor-pointer', isOpen && styles.active)}
            error={error}
            hintText={hintText}
            startIcon={startIcon}
            endIcon={IconChevronDown}
        />
    );
};
